import { useQuery } from '@tanstack/react-query';

import type { MultiProcessOfferDto } from '@/api/generated';

import { useProcessApiClient } from '@/api/clients/useProcessApiClient.util.ts';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useUserContext } from '@/contexts/userContext/User.context.ts';

type Return = {
  isPending: boolean;
  multiOffers: MultiProcessOfferDto[];
};

export const useGetProcessMultiOffers = (params: { processId: string }): Return => {
  const { processMultiOffersApi } = useProcessApiClient();
  const { userId } = useUserContext();

  const { data, isPending } = useQuery<MultiProcessOfferDto[]>({
    enabled: Boolean(params.processId),
    queryFn: async () => {
      const { data } = await processMultiOffersApi.getMultiProcessOffers(userId, params.processId);
      return data;
    },
    queryKey: [QueryKeyEnum.PROCESS.MULTI_OFFERS, params.processId],
  });

  return {
    isPending,
    multiOffers: data ?? [],
  };
};
